var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10.6957V16.1124C1.5 17.1096 2.30837 17.918 3.30556 17.918H14.1389C15.1361 17.918 15.9444 17.1096 15.9444 16.1124V10.6957M8.72226 1.66797V12.5013M8.72226 12.5013L5.56254 9.34158M8.72226 12.5013L11.882 9.34158",
    stroke: "#3A3737",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadList);
export default __webpack_public_path__ + "static/media/downloadList.bf186c17ce5aed7b5152cfcaca466a45.svg";
export { ForwardRef as ReactComponent };